<template>
  <beer itemId="2000000002" itemName="snowitt" title="Snowitt, 12,5 °P, Witbier">
    <p
      style="
          margin: auto;
          text-align: justify;
          max-width: 40rem;
          width: 100%;
          margin-top: 4rem;
        "
    >
      Svrchně kvašené pšeničné pivo s nízkou hořkostí. Tento pivní styl pocházející z Belgie se díky přidané pomerančové
      kůře a koriandru vyznačuje svěžím aromatem. Vzhledem k jeho typicky světlé barvě, od které je také odvozen jeho
      název (<span style="font-style: italic">„wit“</span>
      = bílý), jsme pojmenovali toto pivo Snowitt. Jeho citrusovou svěžest oceníte zejména za horkých letních dnů.
    </p>

    <table
      class="tg"
      style="
          margin: auto;
          text-align: left;
          max-width: 40rem;
          width: 100%;
          margin-top: 4rem;
        "
    >
      <tbody>
        <tr>
          <td class="bold">Pivní styl</td>
          <td class="right">Witbier</td>
        </tr>
        <tr>
          <td>Stupňovitost</td>
          <td class="right">12,5 °P</td>
        </tr>
        <tr>
          <td>Alkohol</td>
          <td class="right">4.5 %</td>
        </tr>
        <tr>
          <td>Barva</td>
          <td class="right">3,6 SRM</td>
        </tr>
        <tr>
          <td>Hořkost</td>
          <td class="right">16 IBU</td>
        </tr>
        <tr>
          <td>Slady</td>
          <td class="right">pšeničný, pale ale, kyselý</td>
        </tr>
        <tr>
          <td>Chmely</td>
          <td class="right">Hallertau Magnum</td>
        </tr>
      </tbody>
    </table>
  </beer>
</template>

<script>
import Beer from "../Beer";
export default {
  name: "Snowitt",
  components: { Beer },
};
</script>
